import { render, staticRenderFns } from "./NewForum.vue?vue&type=template&id=732a7ee7"
import script from "./NewForum.vue?vue&type=script&lang=js"
export * from "./NewForum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports